function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 259 196",
  className: styles["hero-title__image"] || "hero-title__image"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M254.958 46.37 225.33 21.752a.484.484 0 0 0-.471-.083l-36.133 13.35a.488.488 0 0 0-.306.364l-6.506 37.969a.483.483 0 0 0 .165.446l29.628 24.618c.132.108.306.141.471.083l36.134-13.35a.492.492 0 0 0 .306-.364l6.505-37.969a.483.483 0 0 0-.165-.446Z",
  fill: "#FDE780"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.856 98.144a5 5 0 0 1-3.174-1.141l-25.834-21.46a4.986 4.986 0 0 1-1.719-4.655l5.671-33.1a4.974 4.974 0 0 1 3.166-3.818l31.496-11.64a4.995 4.995 0 0 1 4.894.835l25.833 21.469a4.986 4.986 0 0 1 1.72 4.654l-5.671 33.1a4.976 4.976 0 0 1-3.166 3.819l-31.496 11.64a5.16 5.16 0 0 1-1.72.297Zm11.325-75.698c-.529 0-1.058.09-1.57.28l-31.496 11.64a4.561 4.561 0 0 0-2.91 3.497l-5.671 33.092a4.557 4.557 0 0 0 1.579 4.265l25.833 21.46a4.56 4.56 0 0 0 4.481.77l31.496-11.64a4.576 4.576 0 0 0 2.91-3.497l5.671-33.1a4.56 4.56 0 0 0-1.579-4.265l-25.834-21.46a4.549 4.549 0 0 0-2.91-1.042Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.395 84.917c.595 1.281 3.207 1.248 2.926 2.728-.132.695-1.083 1.157-2.108 1.405-1.174.29-2.447.29-2.678.017-.372-.455.752-2.414.71-3.472a4.22 4.22 0 0 0 1.117-.72l.033.042ZM93.13 83.537c-.736.247-1.455.24-2.29 0-2.612-.761-6.349-3.77-15.376-8.06-15.79-7.49-23.411-13.864-27.321-29.149-4.877-19.054 6.812-32.694 19.873-37.109 13.938-4.712 30.628-.653 38.308 17.451 6.167 14.516 3.968 24.213-4.034 39.746-4.332 8.39-5.589 13.012-7.077 15.343-.587.926-1.215 1.488-2.083 1.778Z",
  fill: "#FDE780"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.213 81.76c.29 1.495-.149 2.471-.852 3.116-.33.306-.719.537-1.116.719-1.24.554-1.86-.819-2.405-2.058.835.24 1.554.247 2.29 0 .868-.29 1.496-.852 2.083-1.778Z",
  fill: "#FFC629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.057 194.955c-.521-6.192-26.098-79.327-33.802-100.473-.223-.62-.438-1.2-.637-1.728-.653-1.786-1.124-3.017-1.364-3.596-.008-.041-.025-.075-.041-.108",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.247 89.158c-.802.29-3.91.91-.868 2.389.892.438 1.653.843 2.24 1.207 1.397.851 1.802 1.463.736 1.711a.412.412 0 0 1-.1.017c-1.562.347-5.2.628-3.257 1.463 1.984.851 3.092 1.48 2.58 2.348-.521.868-2.844.62-2.001 1.438s3.82 2.149 2.81 2.728c-1.008.579-3.91.314-3.083 1.496.835 1.191 4.53 1.968 3.894 2.91-.637.943-3.356.041-3.117 1.571.24 1.529 4.225 1.893 3.332 3.017M90.84 83.537c.545 1.24 1.165 2.612 2.405 2.058a4.223 4.223 0 0 0 1.116-.72c.703-.644 1.141-1.62.852-3.116",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.246 85.595c.04 1.058-1.083 3.017-.711 3.472.231.273 1.504.273 2.678-.017 1.025-.248 1.976-.71 2.108-1.405.281-1.48-2.331-1.447-2.926-2.728M90.84 83.537c.835.24 1.554.247 2.29 0 .868-.29 1.496-.852 2.083-1.778 1.488-2.331 2.745-6.952 7.077-15.343 8.002-15.533 10.201-25.23 4.034-39.746-7.68-18.104-24.37-22.163-38.308-17.45-13.061 4.414-24.75 18.054-19.873 37.108 3.91 15.285 11.532 21.659 27.321 29.148 9.027 4.29 12.764 7.3 15.376 8.06Z",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.752 102.823 3.762-2.497c-1.389 1.025-.273 4.902-1.306 5.597l-1.654 1.099-.173.124c-.24.157-.752.488-1.472.967-1.058.703-4.315-1.843-5.778-.876l4.166-2.777c.224.529.752.892 1.364.892.827 0 1.488-.661 1.488-1.488 0-.413-.124-.768-.397-1.041Z",
  fill: "#E3AA1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.888 91.233a4.751 4.751 0 0 1-2.108 4.257l-7.266 4.836-3.761 2.497-2.456 1.636-4.166 2.778h-.008l-8.622 5.737a4.736 4.736 0 0 1-4.745.298L20.475 99.26a4.76 4.76 0 0 1-2.638-3.96l-2-31.496a4.763 4.763 0 0 1 2.116-4.266l26.28-17.484a4.775 4.775 0 0 1 4.745-.297L77.25 55.769a4.754 4.754 0 0 1 2.637 3.96l2 31.504Z",
  fill: "#FFC629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.42 108.444c-.553 0-1.264-.273-2.05-.57-1.132-.439-2.421-.926-3.124-.463a.219.219 0 0 1-.29-.058c-.066-.099-.032-.223.058-.29.877-.578 2.274-.049 3.497.422.926.356 1.877.719 2.282.455.587-.389 1.041-.686 1.314-.868l1.984-1.323c.389-.264.405-1.273.422-2.248.025-1.282.05-2.737.876-3.348a.208.208 0 0 1 .29.041.208.208 0 0 1-.042.289c-.661.488-.686 1.835-.71 3.018-.017 1.182-.042 2.198-.604 2.579l-1.984 1.331c-.273.182-.728.471-1.315.859a.997.997 0 0 1-.603.174Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.871 113.974a4.948 4.948 0 0 1-2.207-.52l-28.28-14.012a4.976 4.976 0 0 1-2.753-4.134l-2-31.496a4.99 4.99 0 0 1 2.206-4.447l26.28-17.484a5.001 5.001 0 0 1 4.952-.314L77.34 55.579a4.987 4.987 0 0 1 2.753 4.133l2 31.504a4.97 4.97 0 0 1-2.199 4.44l-7.266 4.835-10.383 6.911a.06.06 0 0 1-.041.017l-8.59 5.72a4.932 4.932 0 0 1-2.744.835ZM46.87 41.476c-.884 0-1.76.256-2.521.752l-26.28 17.484a4.59 4.59 0 0 0-2.025 4.084l2 31.496a4.542 4.542 0 0 0 2.521 3.786l28.28 14.012a4.55 4.55 0 0 0 4.54-.281l8.621-5.737a.06.06 0 0 1 .042-.017l17.616-11.73a4.57 4.57 0 0 0 2.017-4.076l-2-31.504a4.553 4.553 0 0 0-2.522-3.786l-28.272-14.02a4.559 4.559 0 0 0-2.017-.463Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.66 105.559c-.686 0-1.29-.397-1.554-1.017a.218.218 0 0 1 .108-.273.218.218 0 0 1 .273.108 1.27 1.27 0 0 0 1.174.769c.702 0 1.28-.579 1.28-1.282 0-.372-.115-.669-.338-.893a.2.2 0 0 1 0-.289c.083-.074.215-.083.29 0 .305.306.454.703.454 1.191a1.683 1.683 0 0 1-1.686 1.686Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.623 167.559c9.606-6.936 37.572-19.708 51.617-23.006",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.58 143.569c8.912-4.96 18.121-9.44 24.502-11.59",
  stroke: "#FDE780",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.959 175.941c11.747-4.612 25.809-6.324 38.357-4.877",
  stroke: "#FEFBED",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.834 140.395c11.854 1.107 33.563 15.541 39.424 24.452",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.316 152.166c-8.134-4.447-33.331-9.977-29.975-1.405 1.96 4.993 6.134-8.944-15.525-12.218",
  stroke: "#FDE780",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.956 46.543c12.681 1.802 24.064 11.49 22.948 28.57-.901 13.698-6.399 20.369-18.708 29.313-8.713 6.324-10.796 9.689-13.326 9.747a3.46 3.46 0 0 1-.496-.033c-1.24-.174-2.083-1.017-3.257-2.703-1.446-2.084-3.422-5.465-7.316-10.474-9.341-12.003-12.772-19.948-9.82-33.356 3.67-16.715 18.104-22.742 29.975-21.064Z",
  fill: "#FF8000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.375 114.14c.174.025.339.033.496.033v.107c-.463.951-.975 1.116-1.529 1.042-.422-.058-.868-.256-1.339-.364-1.1-.248-1.141-2.43-.885-3.521 1.174 1.686 2.017 2.529 3.257 2.703Z",
  fill: "#E3AA1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.811 116.901c-.033-.48 1.686-1.215 2.191-1.943.471.108.917.306 1.339.364-.24 1.149 1.256 2.174.331 3.017-.918.843-3.836-.893-3.861-1.438Z",
  fill: "#FF8000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.755 118.447c-2.05 1.496-2.133 3.745-1.835 7.225.297 3.48-4.473 7.82-4.745 11.358-.281 3.538.835 9.49.074 12.02-.76 2.53-4.1 6.911-4.563 12.086-.463 5.183-2.397 24.056-2.885 28.412M140.118 111.437c-.256 1.091-.215 3.273.885 3.521.471.108.917.306 1.339.364.554.074 1.066-.091 1.529-1.042",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.002 114.958c-.505.728-2.224 1.463-2.191 1.943.025.545 2.943 2.281 3.861 1.438.925-.843-.571-1.868-.331-3.017M140.117 111.437c1.174 1.686 2.017 2.529 3.257 2.703.174.025.339.033.496.033 2.53-.058 4.613-3.423 13.326-9.747 12.309-8.944 17.807-15.615 18.708-29.313 1.116-17.08-10.267-26.768-22.948-28.57-11.871-1.678-26.305 4.349-29.975 21.064-2.952 13.408.479 21.353 9.82 33.356 3.894 5.009 5.87 8.39 7.316 10.474Z",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M158.379 53.958c-3.009-1.703-7.168-2.223-9.292.19-2.439 2.778-.719 5.886 1.157 7.746 5.911 5.886 9.672 3.042 12.285 12.012.653 2.24 1.62 5.555 4.067 5.191 2.042-.305 2.372-3.017 2.422-5.158.116-5.167-3.497-15.93-10.639-19.98Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.682 104.129c3.579-2.827 13.706-11.764 14.45-15.79",
  stroke: "#fff",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M85.227 12.17c-3.19-1.33-7.382-1.347-9.2 1.306-2.092 3.05-.009 5.928 2.082 7.556 6.572 5.134 9.97 1.86 13.64 10.45.918 2.149 2.274 5.315 4.655 4.662 1.984-.546 1.992-3.282 1.785-5.407-.512-5.15-5.381-15.409-12.962-18.567Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 21.52c-6.945 5.605-6.606 14.558-4.639 20.303",
  stroke: "#fff",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.917 86.52c-.008.017-.017.026-.025.042-.364.645-.752 1.323-1.149 2.017-15.55 26.925-57.792 89.272-71.755 100.804",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.031 72.145c2.604 1.281 7.25 1.19 7.25 1.19M186.445 70.318c.686-.182 2.207-.339 4.324-1.53M242.195 70.326c1.678 1.183 3.29 3.91 3.621 6.531M240.27 78.13c1.488 1.629 3.72 1.76 5.241 1.505M199.969 36.863c3.463-1.901 14.07-8.242 20.104-7.357",
  stroke: "#fff",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.515 89.1c-.025-.016-.05-.041-.075-.05-1.463-1.058-4.662 1.265-5.679.43-.454-.38-.818-.678-1.083-.9-.339-.282-.52-.43-.52-.43s-.579-.488-1.612-1.34c-1.026-.851.744-4.53-.687-5.72",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M237.781 46.932a1.341 1.341 0 0 1 1.356 1.512l-1.067 7.928a1.322 1.322 0 0 1-1.281 1.158h-.033c-.67 0-1.248-.496-1.331-1.174l-.959-7.87a1.338 1.338 0 0 1 1.29-1.496l2.025-.058ZM230.712 52.164a2.077 2.077 0 0 1-1.174 2.282 2.059 2.059 0 0 1-2.695-.975l-5.183-10.64c-.612-1.256.182-2.76 1.571-2.943a24.968 24.968 0 0 1 3.34-.198 2.06 2.06 0 0 1 2 1.662l2.141 10.813Z",
  fill: "#FEFBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.36 97.044c1.273.505 1.15 2.34-.181 2.67l-8.648 2.15a1.405 1.405 0 0 1-1.702-1.711l1.29-5.068a1.401 1.401 0 0 1 1.876-.967l7.365 2.926Z",
  fill: "#E3AA1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.363 105.237c.323.628.67 1.264 1.017 1.909 15.806 28.917 57.247 74.863 58.809 76.665",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.955 70.525c.132 5.919.595 13.243 1.968 18.129M24.104 95.837c2.579 1.348 7.216 1.397 7.216 1.397M24.574 94.027c.695-.165 2.216-.281 4.365-1.414M66.926 60.282c1.711-1.132 4.836-1.653 7.398-1.025M73.522 64.78c2.05-.81 2.975-2.844 3.281-4.349",
  stroke: "#fff",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.307 23.914c.356-.88-.527-2.067-1.971-2.65-1.443-.582-2.902-.34-3.257.54-.355.881.527 2.068 1.971 2.65 1.444.582 2.902.34 3.257-.54ZM101.762 21.247c1.557 0 2.819-.592 2.819-1.323 0-.73-1.262-1.322-2.819-1.322s-2.819.592-2.819 1.322c0 .731 1.262 1.323 2.819 1.323ZM122.707 27.439c.459-.574-.153-1.828-1.368-2.802-1.215-.973-2.573-1.297-3.032-.724-.46.574.153 1.828 1.368 2.802 1.214.973 2.572 1.297 3.032.724ZM100.553 46.188a2.182 2.182 0 1 0 .001-4.365 2.182 2.182 0 0 0-.001 4.365ZM111.706 53.66a2.182 2.182 0 1 0 0-4.364 2.182 2.182 0 0 0 0 4.365ZM95.214 61.812a2.182 2.182 0 1 0 0-4.365 2.182 2.182 0 0 0 0 4.365ZM99.531 29.808c1.14-1.06 1.539-2.484.892-3.18-.648-.694-2.096-.397-3.235.664-1.14 1.06-1.538 2.484-.891 3.18.647.694 2.095.397 3.234-.664ZM112.19 35.056c.469-1.485-.217-3.025-1.532-3.44-1.314-.415-2.76.452-3.229 1.936-.469 1.485.217 3.025 1.532 3.44 1.315.415 2.76-.452 3.229-1.936ZM90.086 22.865c1.14-1.061 1.8-2.203 1.477-2.55-.323-.348-1.51.23-2.648 1.291-1.14 1.061-1.801 2.203-1.478 2.55.324.348 1.51-.23 2.65-1.291ZM79.516 35.176c.648-1.415.823-2.723.391-2.92-.431-.198-1.306.789-1.954 2.205-.648 1.415-.824 2.723-.392 2.92.432.198 1.307-.789 1.955-2.205ZM83.84 41.911c.076-1.555-.632-2.853-1.58-2.899-.949-.046-1.779 1.178-1.854 2.733-.075 1.555.632 2.852 1.58 2.898.95.046 1.78-1.177 1.855-2.732Z",
  fill: "#FFC629"
}), /*#__PURE__*/React.createElement("g", {
  opacity: ".5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M129.032 32.035c5.861 13.847 3.753 23.08-3.894 37.878-4.166 8.052-5.357 12.458-6.795 14.657-.554.851-1.141 1.372-1.959 1.645-.662.223-1.306.223-2.042.033-2.488-.653-6.018-3.563-14.781-7.73-15.037-7.158-22.295-13.243-25.999-27.817-4.62-18.162 6.531-31.148 18.98-35.34 13.293-4.472 29.19-.587 36.49 16.674ZM117.856 86.769c.438 1.223 3 1.72 2.62 3.067-.174.628-1.099.975-2.075 1.124-1.099.157-2.257.05-2.447-.215-.306-.438.893-2.15.934-3.133l-.074-.165c.397-.166.76-.372 1.042-.678Z",
  fill: "#FEFBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.359 84.586c.116 1.075-.107 1.736-.504 2.183-.281.306-.645.512-1.041.678a6.897 6.897 0 0 1-.43.165c-1.182.422-1.629-.182-2.042-1.364.736.19 1.38.19 2.042-.033.818-.273 1.405-.794 1.959-1.645l.016.016Z",
  fill: "#FDE780"
})), /*#__PURE__*/React.createElement("path", {
  d: "M114.342 86.248c.413 1.182.86 1.786 2.042 1.364.148-.05.289-.107.43-.165.396-.166.76-.372 1.041-.678.397-.447.62-1.108.504-2.183",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.888 87.612c-.041.984-1.24 2.695-.934 3.133.19.265 1.348.372 2.447.215.976-.149 1.901-.496 2.075-1.124.38-1.348-2.182-1.844-2.62-3.067",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.858 194.955c0-6.713-9.54-96.092-10.458-103.995",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.342 86.248c.736.19 1.38.19 2.042-.033.818-.273 1.405-.794 1.959-1.645 1.438-2.199 2.629-6.605 6.795-14.657 7.647-14.797 9.755-24.031 3.894-37.878-7.3-17.26-23.197-21.146-36.49-16.674-12.449 4.192-23.6 17.178-18.98 35.34C77.266 65.275 84.524 71.36 99.561 78.52c8.763 4.166 12.293 7.076 14.781 7.729Z",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M118.187 24.281c-2.339-2.496-6.117-4.216-8.837-2.563-3.125 1.91-2.414 5.349-1.19 7.664 3.852 7.3 8.25 5.728 8.068 14.979-.042 2.315-.108 5.729 2.315 6.1 2.017.315 3.133-2.157 3.81-4.157 1.629-4.845 1.398-16.088-4.166-22.023Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.228 64.143c6.258 7.903 18.551 10.383 22.097 13.375",
  stroke: "#FEFBED",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.134 120.596c1.868-7.837 1.471-16.021-1.207-23.626l-2.918-8.358c-1.844-5.158 2.802-10.316 8.126-9.027l8.614 2.042c7.845 1.86 16.021 1.405 23.593-1.232l8.391-2.96c5.191-1.81 10.316 2.811 9.06 8.16l-2.067 8.647c-1.835 7.812-1.438 15.988 1.232 23.593l2.926 8.358c1.836 5.158-2.81 10.316-8.134 9.027l-8.614-2.034c-7.837-1.868-16.021-1.405-23.618 1.265l-8.357 2.926a6.942 6.942 0 0 1-3.762.24h-.008l-1.389-.463a5.563 5.563 0 0 1-.62-.33 6.886 6.886 0 0 1-2.133-1.918 6.602 6.602 0 0 1-.992-1.926 6.822 6.822 0 0 1-.157-3.77l2.034-8.614Zm43.904-24.246.397 5.423c.041.595.603 1 1.182.851l.835-.215a.945.945 0 0 0 .686-1.14l-1.223-5.208a.968.968 0 0 0-.926-.736.954.954 0 0 0-.951 1.025Zm-.157 19.203-1.893-14.466a1.28 1.28 0 0 0-1.356-1.108c-.644.05-1.157.57-1.182 1.215l-.653 14.649a1.27 1.27 0 0 0 1.364 1.322l2.546-.181a1.278 1.278 0 0 0 1.174-1.431Z",
  fill: "#FFC629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.256 132.979c.224.703.563 1.348.992 1.927l-.008.008c-.529.587-.595 1.604 0 2.141a19.156 19.156 0 0 1-1.124 1.678c-.074-.058-.149-.116-.223-.182a3.465 3.465 0 0 1-.257-4.894l.612-.678h.008Z",
  fill: "#FFC629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.241 137.055c.596.529 1.604.372 2.142-.223v-.009c.198.124.405.232.62.331l1.388.463h.009l-.612.678a3.466 3.466 0 0 1-4.671.438c.471-.636.843-1.199 1.124-1.678Z",
  fill: "#FEFBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.138 101.269a.945.945 0 0 1-.686 1.14l-.835.215a.942.942 0 0 1-1.182-.851l-.397-5.423a.954.954 0 0 1 .95-1.025.966.966 0 0 1 .926.736l1.224 5.208Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.882 115.553a1.278 1.278 0 0 1-1.174 1.431l-2.546.181a1.27 1.27 0 0 1-1.364-1.322l.653-14.649a1.277 1.277 0 0 1 1.182-1.215 1.28 1.28 0 0 1 1.356 1.108l1.893 14.466Z",
  fill: "#FDE780"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.242 137.055a19.156 19.156 0 0 1-1.124 1.678c-8.424 11.383-45.756 45.665-53.725 56.222M177.391 137.617h.008a6.942 6.942 0 0 0 3.762-.24l8.357-2.926c7.597-2.67 15.781-3.133 23.618-1.265l8.614 2.034c5.324 1.289 9.97-3.869 8.134-9.027l-2.926-8.358c-2.67-7.605-3.067-15.781-1.232-23.593l2.067-8.647c1.256-5.349-3.869-9.97-9.06-8.16l-8.391 2.96c-7.572 2.637-15.748 3.092-23.593 1.232l-8.614-2.042c-5.324-1.29-9.97 3.869-8.126 9.027l2.918 8.358c2.678 7.605 3.075 15.789 1.207 23.626l-2.034 8.614a6.822 6.822 0 0 0 .157 3.77c.224.702.563 1.347.992 1.926a6.886 6.886 0 0 0 2.133 1.918c.199.124.405.231.62.33",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m172.25 132.979-.612.678a3.465 3.465 0 0 0 5.151 4.638l.611-.678",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.383 136.832c-.537.595-1.546.752-2.141.223-.595-.537-.529-1.554 0-2.141",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.129 84.496a3.678 3.678 0 0 1-.57 4.05M192.809 84.884a3.666 3.666 0 0 1-.571 4.042M201.539 85c.736 1.546.909 2.347.628 4.224M208.938 83.247c.52.405 1.678 1.224 2.165 2.323",
  stroke: "#FDE780",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.672 96.102c1.025.917 2.893 2.017 4.414 1.752M177.416 101.963c.579.934 1.364 1.703 2.53 2.273M177.533 108.237c.645 1.703 1.629 2.547 2.588 3.001",
  stroke: "#E3AA1F",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.492 131.665c4.63.744 20.584-7.151 28.867-3.993",
  stroke: "#FDE780",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.733 132.831h-2.331a.824.824 0 0 1-.786-.587l-.727-2.406a.82.82 0 0 1 .785-1.058h2.331c.364 0 .678.24.785.587l.728 2.406a.82.82 0 0 1-.785 1.058ZM43.11 80.66h-2.332a.823.823 0 0 1-.785-.587l-.727-2.406a.82.82 0 0 1 .785-1.058h2.331c.364 0 .678.24.785.587l.728 2.406a.82.82 0 0 1-.785 1.058ZM108.481 15.502h-2.331a.824.824 0 0 1-.786-.587l-.727-2.406a.82.82 0 0 1 .785-1.058h2.331c.364 0 .678.24.786.587l.727 2.406a.823.823 0 0 1-.785 1.058ZM188.9 148.876h2.331c.364 0 .678-.347.786-.859l.727-3.539c.157-.777-.231-1.554-.785-1.554h-2.331c-.364 0-.678.348-.786.86l-.727 3.538c-.157.777.239 1.554.785 1.554ZM80.383 128.119h2.331c.364 0 .678-.348.785-.86l.728-3.538c.157-.777-.231-1.554-.785-1.554H81.11c-.363 0-.677.347-.785.859l-.727 3.539c-.157.777.231 1.554.785 1.554ZM43.53 60.621a1.637 1.637 0 1 0 0-3.273 1.637 1.637 0 0 0 0 3.273ZM204.068 48.759a1.637 1.637 0 1 0 0-3.274 1.637 1.637 0 0 0 0 3.274ZM235.516 24.108a1.637 1.637 0 1 0 0-3.275 1.637 1.637 0 0 0 0 3.275ZM19.383 33.308a1.637 1.637 0 1 0 0-3.273 1.637 1.637 0 0 0 0 3.273ZM113.541 115.38a1.637 1.637 0 1 0 0-3.274 1.637 1.637 0 0 0 0 3.274ZM236.292 104.633l1.984 1.224c.306.19.76.057 1.116-.323l2.472-2.637c.537-.579.611-1.447.148-1.736l-1.984-1.223c-.305-.19-.76-.058-1.116.322l-2.471 2.637c-.546.579-.62 1.447-.149 1.736Z",
  fill: "#fff",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.8 182.241c-1.232.553-.653 2.074 2.901 2.438",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.604 47.47a4.761 4.761 0 0 1-1.388 4.546l-24.577 22.882a4.748 4.748 0 0 1-4.638 1.066l-11.309-3.463-4.373-1.34-3.224-.992-4.356-1.33-.017-.009-8.829-2.703a4.776 4.776 0 0 1-3.24-3.48l-7.523-32.728a4.746 4.746 0 0 1 1.389-4.547L149.096 2.49a4.762 4.762 0 0 1 4.637-1.066l32.1 9.845a4.736 4.736 0 0 1 3.24 3.472l7.531 32.728Z",
  fill: "#FEFBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "m150.319 71.161 4.373 1.34c-1.761-.406-3.844 3.463-5.109 3.091-.57-.173-1.017-.306-1.347-.413-.422-.124-.653-.19-.653-.19s-.72-.223-2.001-.604c-1.273-.388-1.083-4.985-2.844-5.547l4.357 1.331-.008.042a1.676 1.676 0 0 0 1.397 2.157 1.676 1.676 0 0 0 1.827-1.19l.008-.017Z",
  fill: "#FDE780"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.692 72.5c-1.761-.405-3.844 3.464-5.109 3.092-.57-.173-1.017-.306-1.347-.413-.422-.124-.653-.19-.653-.19s-.72-.223-2.001-.604c-1.273-.388-1.083-4.985-2.844-5.547",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.312 71.178a1.675 1.675 0 0 1-1.827 1.19c-.091-.008-.182-.033-.273-.058a1.676 1.676 0 0 1-1.124-2.1M154.692 72.5l11.309 3.464c1.629.505 3.39.091 4.638-1.066l24.577-22.882a4.761 4.761 0 0 0 1.388-4.547l-7.531-32.728a4.736 4.736 0 0 0-3.24-3.472l-32.1-9.845a4.762 4.762 0 0 0-4.637 1.066l-24.577 22.882a4.746 4.746 0 0 0-1.389 4.547l7.523 32.728a4.776 4.776 0 0 0 3.24 3.48l8.829 2.703.017.008 4.356 1.331 3.224.992 4.373 1.34Z",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.483 72.368c-.082.736-.215 1.439-.306 2.232-3.827 30.86-18.434 104.739-26.8 120.801",
  stroke: "#141414",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.662 62.473c2.902.165 7.143-1.728 7.143-1.728M134.332 60.63c.562-.439 1.901-1.174 3.389-3.092M134.836 24.686c2.447-3.1 9.746-13.07 15.649-14.607",
  stroke: "#FDE780",
  strokeWidth: ".5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.367 41.352c.769.231 1.414-.273 1.728-.513l3.927-3.695a2.102 2.102 0 0 0 .603-1.992l-1.124-4.77a2.073 2.073 0 0 0-1.422-1.513l-5.233-1.579a2.07 2.07 0 0 0-2.025.48l-3.704 3.513a2.07 2.07 0 0 0-.595 1.976l1.149 4.968a2.072 2.072 0 0 0 1.422 1.521l5.274 1.604ZM173.697 48.808c.769.232 1.414-.273 1.728-.512l3.927-3.695a2.103 2.103 0 0 0 .603-1.993l-1.124-4.77a2.073 2.073 0 0 0-1.422-1.512l-5.233-1.58a2.07 2.07 0 0 0-2.025.48l-3.703 3.514a2.069 2.069 0 0 0-.596 1.975l1.149 4.968a2.072 2.072 0 0 0 1.422 1.522l5.274 1.603Z",
  fill: "#FDE780"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.942 52.132c.768.23 1.413-.273 1.727-.513l3.927-3.695a2.102 2.102 0 0 0 .603-1.992l-1.124-4.77a2.073 2.073 0 0 0-1.422-1.513l-5.233-1.58a2.07 2.07 0 0 0-2.025.48l-3.703 3.514a2.069 2.069 0 0 0-.596 1.975l1.15 4.969c.165.727.71 1.306 1.421 1.52l5.275 1.605ZM163.555 38.17c.769.23 1.413-.274 1.728-.514l3.926-3.695a2.103 2.103 0 0 0 .604-1.992l-1.125-4.77a2.073 2.073 0 0 0-1.421-1.513l-5.233-1.578a2.072 2.072 0 0 0-2.026.479l-3.703 3.513a2.068 2.068 0 0 0-.595 1.976l1.149 4.968a2.07 2.07 0 0 0 1.422 1.521l5.274 1.604Z",
  fill: "#FFC629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.209 65.722c.975.388.885 1.802-.141 2.05l-6.646 1.653a1.076 1.076 0 0 1-1.306-1.314l.992-3.894a1.081 1.081 0 0 1 1.447-.744l5.654 2.249Z",
  fill: "#FDE780"
}));